// extracted by mini-css-extract-plugin
module.exports = {"medium":"only screen and (min-width: 768px)","cardWrapper":"_1YQJK","hideOnTabletPortraitAndUp":"_1bX1F"};